
import { KulionerController } from "@/app/ui/controllers/KulionerController";
import { Options, Vue } from "vue-class-component";

@Options({
  watch: {
    "$route.name": {
      handler(routeName: string) {
        if (routeName === "kulioner-merchant" || !this.cycles.length) {
          this.getCycleList();
        }
      },
      immediate: true
    }
  }
})
class MerchantView extends Vue {
  cycles: any[] = [];
  isLoadingCycles = true;

  get cycleTriggers() {
    return {
      routerName: this.$route.name,
      cycles: this.cycles
    };
  }

  async getCycleList() {
    try {
      this.isLoadingCycles = true;
      const resp = await KulionerController.getCycleList();
      this.cycles = resp.map((cycle, index) => {
        const hour = cycle.cutOffTime.split(":")[0];
        const minute = cycle.cutOffTime.split(":")[1];
        const second = cycle.cutOffTime.split(":")[2] || "00";

        const time = new Date(
          new Date().setHours(Number(hour), Number(minute), Number(second), 0)
        );
        const timeLabel = this.$moment(time).format("HH:mm");
        return {
          ...cycle,
          name: this.$t("kulioner.merchant.cycleName", {
            index: index + 1,
            time: timeLabel
          }) as string,
          id: cycle.cutOffTime,
          ids: cycle.id.join(","),
          time: time
        };
      });
      let currentCycleId = this.cycles[0].id
      
      if (this.cycles.length > 1) {
        // match current time with cycle time
        const now = new Date();
        const currentCycle = this.cycles.find(cycle => cycle.time >= now);
        if (currentCycle) {
          currentCycleId = currentCycle.id;
        }
      }
      this.$router.replace({
        name: "kulioner-merchant-tab-cycle",
        params: { id: currentCycleId },
      });
    } catch (error) {
      console.error("Error fetching cycle list:", error);
    } finally {
      this.isLoadingCycles = false;
    }
  }
}
export default MerchantView;
